import React from 'react';
import { Image } from '@fiverr-private/media';
import { OMR_BADGE_IMAGE_SRC } from './constants';

export const OmrBadge = () => (
    <Image
        src={OMR_BADGE_IMAGE_SRC}
        alt="OMR badge"
        display="block"
        width="auto"
        height={{
            default: '110px',
            lg: '130px',
        }}
    />
);
